import React from "react";
import { useImageFallback } from "@/common/hooks/use-image-fallback.hook";

const NO_IMAGE_PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='152' height='152'%3E%3Crect width='152' height='152' fill='%23eee'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23999' font-size='14'%3ENo Image%3C/text%3E%3C/svg%3E";

export interface ProductImageProps {
  logoUrl?: string;
  altText: string;
  size?: number;
  dataTestId?: string;
  className?: string;
}

/**
 * Renders a square product image with a consistent no-image placeholder fallback.
 * Used across the PDP, checkout side panel, and search results.
 */
export const ProductImage: React.FC<ProductImageProps> = ({
  logoUrl,
  altText,
  size = 110,
  dataTestId = "product-image",
  className,
}) => {
  const image = useImageFallback(logoUrl, NO_IMAGE_PLACEHOLDER);

  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        padding: 12,
        borderRadius: 8,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#FFF",
        border: "1.5px solid #D1D5DA",
        boxShadow: "4px 4px 8px 0 rgba(139, 150, 163, 0.20)",
      }}
    >
      <img
        src={image.src}
        onError={image.onError}
        alt={altText}
        data-testid={dataTestId}
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  );
};
